module.exports = __webpack_public_path__ + "static/media/65.a99924ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/65.png
// module id = 639
// module chunks = 0